/* ELSA – Yorumcu adı gizliliği
   Judge.me yorumlarında iki ve daha fazla kelimelik yorumcu adlarını baş harflere çevirir
   ("Ahmet Yılmaz" → "A.Y."). Zaten kısaltılmış adlara ("E.Ç.") dokunmaz.
   Hem görünen widget'a hem de Google'a giden JSON-LD (Review.author.name) verisine uygulanır. */
(function () {
  function toInitials(name) {
    if (typeof name !== 'string') return name;
    var clean = name.trim();
    var words = clean.split(/\s+/).filter(Boolean);
    if (words.length < 2) return name;
    if (words.every(function (w) { return /^[^\s]\.?$/.test(w) || /^([^\s]\.)+$/.test(w); })) return name;
    return words.map(function (w) { return w.charAt(0).toLocaleUpperCase('tr-TR') + '.'; }).join('');
  }

  function fixJsonLd() {
    document.querySelectorAll('script[type="application/ld+json"]').forEach(function (script) {
      if (script.dataset.elsaPrivacy) return;
      var data;
      try { data = JSON.parse(script.textContent); } catch (e) { return; }
      var changed = false;
      (function walk(node) {
        if (!node || typeof node !== 'object') return;
        if (Array.isArray(node)) { node.forEach(walk); return; }
        if (node['@type'] === 'Review' && node.author && typeof node.author.name === 'string') {
          var short = toInitials(node.author.name);
          if (short !== node.author.name) { node.author.name = short; changed = true; }
        }
        Object.keys(node).forEach(function (k) { walk(node[k]); });
      })(data);
      if (changed) script.textContent = JSON.stringify(data);
      script.dataset.elsaPrivacy = '1';
    });
  }

  function fixWidget(root) {
    (root || document).querySelectorAll('.jdgm-rev__author, .jdgm-rev__author-wrapper .jdgm-rev__author, [class*="reviewer-name"]').forEach(function (el) {
      if (el.childElementCount > 0) return;
      var text = el.textContent;
      var short = toInitials(text);
      if (short !== text) el.textContent = short;
    });
  }

  function run() {
    fixJsonLd();
    fixWidget();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  // Judge.me yorumları sonradan (sayfalama, sıralama) yüklediği için değişiklikleri izle; 30 sn sonra dur.
  var observer = new MutationObserver(function () { run(); });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  setTimeout(function () { observer.disconnect(); }, 30000);
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#judgeme_product_reviews')) setTimeout(run, 800);
  });
})();
